import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    lang: "ja",
    langPath: "",
  },
  mutations: {
    switchLang(state, lang) {
      state.lang = lang;
      state.langPath = lang === "en" ? "en/" : "";
    },
  },
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js